import type { ComponentConfig } from "@puckeditor/core"
import { SectionBase, sectionStyle } from "../lib/section"

export type TextProps = SectionBase & {
  align: "left" | "center" | "right"
  text: string
}

export const Text: ComponentConfig<TextProps> = {
  fields: {
    text: { type: "textarea", label: "Paragraphs (blank line separates paragraphs)" },
    align: {
      type: "radio",
      options: [
        { value: "left", label: "Left" },
        { value: "center", label: "Center" },
        { value: "right", label: "Right" },
      ],
    },
    background: {
      type: "radio",
      options: [
        { value: "none", label: "Transparent" },
        { value: "muted", label: "Muted" },
        { value: "accent", label: "Dark" },
      ],
    },
    paddingY: {
      type: "radio",
      options: [
        { value: "none", label: "None" },
        { value: "sm", label: "Small" },
        { value: "md", label: "Medium" },
        { value: "lg", label: "Large" },
      ],
    },
  },

  defaultProps: {
    text: "Write your content here.",
    align: "left",
    background: "none",
    paddingY: "md",
  },

  render: ({ text, align, background, paddingY }) => {
    const s = sectionStyle({ background, paddingY })
    const paragraphs = (text || "").split(/\n\s*\n/)

    return (
      <section style={s}>
        <div
          style={{
            maxWidth: 720,
            margin: "0 auto",
            padding: "0 24px",
            textAlign: align,
            ...(align === "center" || align === "right" ? { marginLeft: align === "center" ? "auto" : undefined, marginRight: align === "right" ? "auto" : align === "center" ? "auto" : undefined } : {}),
          }}
        >
          {paragraphs.map((p, i) => (
            <p key={i} style={{ fontSize: "1.0625rem", lineHeight: 1.8, color: "#374151", marginBottom: i < paragraphs.length - 1 ? 16 : 0 }}>
              {p}
            </p>
          ))}
        </div>
      </section>
    )
  },
}
